import {
    SET_ACTIVE_ASSET_REPORT_EXCEL_DATA,
    SET_ACTIVE_ASSET_REPORT_GRID_FILTERS,
    SET_ACTIVE_ASSET_REPORT_GRID_DATA,
    SET_ACTIVE_ASSET_REPORT_DROPDOWN_GRID_DATA,
    SET_IS_REPORT_GRID_DATA_LOADING
} from "./ActiveAssetReportType";

const initialState = {
    activeAssetReportExcelData: null,
    activeAssetReportGridFilters: {},
    activeAssetReportGridData: null,
    activeAssetReportDropdownGridData: null,
    isReportGridDataLoading: false
}

const reducers = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ACTIVE_ASSET_REPORT_EXCEL_DATA:
            return {
                ...state,
                activeAssetReportExcelData: action.activeAssetReportExcelData,
            };
        case SET_ACTIVE_ASSET_REPORT_GRID_FILTERS:
            return {
                ...state,
                activeAssetReportGridFilters: { ...state.activeAssetReportGridFilters, ...action.activeAssetReportGridFilters },
            };
        case SET_ACTIVE_ASSET_REPORT_GRID_DATA:
            return {
                ...state,
                activeAssetReportGridData: action.activeAssetReportGridData,
            };
        case SET_ACTIVE_ASSET_REPORT_DROPDOWN_GRID_DATA:
            return {
                ...state,
                activeAssetReportDropdownGridData: action.activeAssetReportDropdownGridData,
            };
        case SET_IS_REPORT_GRID_DATA_LOADING:
            return {
                ...state,
                isReportGridDataLoading: action.isReportGridDataLoading,
            };
        default:
            return state;
    }
}

export default reducers